const LatestUpdatesCards = ({ latestUpdatesData, language, name }: { latestUpdatesData: any[], language: string, name: string }) => {
    return (
        <>
            {latestUpdatesData && latestUpdatesData.map((item: any, index: number) => {
                let currentMediaType = item.Media[0]?.__component;
                let mediaContent = item.Media[0]?.Media?.url || item.Media[0]?.Youtube || "";
                let mediatype = item.Media[0]?.Media?.ext;
                let currentContentType = item.Content[0]?.__component || "";
                let outerLink = item.Content[0]?.href || "";
                let cat_name = item.Category?.Name || 0;
                const locateSrc = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? '/backend/public' : '';

                let logMediaInfo = () => {
                    return (
                        <div className="update-item" key={index}>
                            <div>
                                <div className="media">
                                    {currentMediaType === "components.title-media" &&
                                        (mediatype === ".mp4" ? (
                                            <video controls>
                                                <source src={mediaContent} type="video/mp4" />
                                            </video>
                                        ) : (
                                            currentContentType === "components.link" ? (
                                                <a href={outerLink} target="_blank"><img src={`${locateSrc}${mediaContent}`} alt={item.Title} /></a>
                                            ) : currentContentType === "components.editor" ? (
                                                <a href={`/${language}/latest-updates/details/${item.pid}`}><img src={`${locateSrc}${mediaContent}`} alt={item.Title} /></a>
                                            ) : null
                                        ))
                                    }
                                    {currentMediaType === "components.video-code" && (
                                        <><iframe id="ytplayer" width="640" height="360"
                                            src={`https://www.youtube.com/embed/${mediaContent}?autoplay=0`}
                                            frameBorder="0"></iframe></>
                                    )}
                                </div>
                                <h2>{item.Title}</h2>
                                <div className="update-desc" dangerouslySetInnerHTML={{ __html: item.ShotContent }} />
                            </div>

                            <div className="date-category">
                                <div className="category-label">{language == "en" ? item.Category?.Title || '' : item.Category?.Zh_title || ''}</div>
                                <div className="update-date">{item.Date}</div>
                            </div>

                            <div className='details-link'>
                                {currentContentType === "components.link" ? (
                                    <div className="read-more"><a href={outerLink} target="_blank">{language === "en" ? "More details" : "更多詳情"}</a></div>
                                ) : currentContentType === "components.editor" ? (
                                    <div className="read-more"><a href={`/${language}/latest-updates/details/${item.pid}`}>{language === "en" ? "More details" : "更多詳情"}</a></div>
                                ) : null}
                            </div>
                        </div>);
                }

                if (name && cat_name == name) {
                    return logMediaInfo();
                }
                if (name == "all") {
                    return logMediaInfo();
                }
                return null;
            })}
        </>
    );
};

export default LatestUpdatesCards;